import { LuCheckCircle, LuXCircle } from 'react-icons/lu';

import { InterviewStatus } from '@/services/api';
import { colors } from '@/theme/foundations/colors';

export const statusIcon = (status: InterviewStatus, size?: number) => {
  switch (status) {
    case InterviewStatus.Positive:
      return <LuCheckCircle fontSize={size ?? 16} />;
    case InterviewStatus.Negative:
      return <LuXCircle fontSize={size ?? 16} color={colors.error[700]} />;

    default:
      return null;
  }
};
